export default (axios, alert) => ({
  /**
   * Plus1-Angebot des Kunden (nur wenn eines vorliegt, sonst 404).
   * GET /customer/plus1/angebot
   */
  angebot () {
    return axios.get('/customer/plus1/angebot').then(({ data }) => data)
  },

  /**
   * Summe des Angebots selbst ändern, einmal je Antrag (nur wenn angebot.summe_aendern gesetzt ist).
   * POST /customer/plus1/angebot/summe-aendern
   */
  summeAendern (summe) {
    return axios.post('/customer/plus1/angebot/summe-aendern', { summe }).then(({ data }) => data)
  },

  /**
   * Nach der eigenen Erhöhung einmal zurück auf die frühere Summe (nur wenn angebot.summe_zurueck gesetzt ist).
   * POST /customer/plus1/angebot/summe-zurueck
   */
  summeZurueck () {
    return axios.post('/customer/plus1/angebot/summe-zurueck').then(({ data }) => data)
  },

  /**
   * Angebot annehmen, die Entscheidung geht ans CRM und von dort an Plus1.
   * POST /customer/plus1/angebot/annehmen
   */
  annehmen () {
    return axios.post('/customer/plus1/angebot/annehmen').then(({ data }) => data)
  },

  /**
   * Angebot ablehnen.
   * POST /customer/plus1/angebot/ablehnen
   */
  ablehnen () {
    return axios.post('/customer/plus1/angebot/ablehnen').then(({ data }) => data)
  }
})
